if (!customElements.get('taster-pack-picker')) {
  customElements.define('taster-pack-picker', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.fields = this.querySelector('[data-taster-fields]');
      this.options = Array.from(this.querySelectorAll('[data-taster-option]'));
      this.button = this.querySelector('[data-add-to-cart-button]');
      this.message = this.querySelector('[data-taster-message]');
      this.cartLink = this.querySelector('[data-taster-cart]');
      this.money = new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: this.dataset.currency });
      this.fields.disabled = false;
      const initial = this.options.find((option) => option.value === '2' && !option.disabled)
        || this.options.find((option) => !option.disabled);
      if (initial) initial.checked = true;
      this.addEventListener('change', () => this.update());
      this.querySelector('form').addEventListener('submit', (event) => this.submit(event));
      this.update();
    }

    update() {
      this.selected = this.options.find((option) => option.checked && !option.disabled);
      this.items = this.selected ? JSON.parse(this.selected.dataset.items) : [];
      this.valid = this.items.length > 0 && this.items.every((item) => Number.isSafeInteger(item.id) && item.id > 0 && item.quantity === 1);
      this.button.disabled = !this.valid || Boolean(this.processing) || Boolean(this.needsReview);
      this.button.querySelector('.add-to-cart-button__label').textContent = this.selected
        ? `Lägg i varukorg | ${this.money.format(Number(this.selected.dataset.price) / 100)}`
        : 'Ej tillgänglig';
    }

    setProcessing(active) {
      this.processing = active;
      this.fields.disabled = active;
      this.button.classList.toggle('is-loading', active);
      this.button.setAttribute('aria-busy', String(active));
      this.button.querySelector('.add-to-cart-button__label').hidden = active;
      this.button.querySelector('.add-to-cart-button__loading-text').hidden = !active;
      this.update();
    }

    submit(event) {
      event.preventDefault();
      if (this.processing || this.needsReview) return;
      this.update();
      if (!this.valid) return;
      if (!window.liquidAjaxCart?.add) {
        this.message.textContent = 'Köpknappen kunde inte laddas. Ladda om sidan och försök igen.';
        return;
      }
      this.message.textContent = '';
      this.cartLink.hidden = true;
      const items = this.items.map((item) => ({ ...item }));
      this.setProcessing(true);
      const finish = (state) => {
        if (state.responseData?.ok && !state.info?.yojSkipFeedback) {
          this.message.textContent = 'Paketet har lagts i varukorgen.';
          document.querySelector('.drawer-cart-opener')?.click();
        } else {
          // A failed batch can be partial or uncertain. Never replay the add.
          this.needsReview = true;
          const description = state.responseData?.body?.description;
          this.message.textContent = `${typeof description === 'string' ? description + ' ' : ''}Kontrollera varukorgen och ladda om sidan innan du försöker igen.`;
        }
        this.cartLink.hidden = false;
        this.setProcessing(false);
      };
      try {
        window.liquidAjaxCart.add({ items }, { info: { initiator: this }, lastCallback: finish });
      } catch {
        finish({});
      }
    }
  });
}
